import action from '../helpers/rest-client'
import axios from 'axios'
import services from '.'
import { paginationString } from '../helpers/getPaginationString'
import {
  NewInspectionOutDto,
  EditInspectionOutDto,
  DeleteInspectionOutDto,
  GetOneInspectionOutDto,
  GetAllInspectionsOutDto,
  InspectionInDto,
  GetInspectionsMetricsOutDto,
} from '../types/inspection.dto'
import { downloadFullInspectionDto, downloadEmptyInspectionDto } from '../types/inspection.dto'


const path = '/inspection'
class Inspection {
  public async new(payload: NewInspectionOutDto) {
    // if (payload?.signer?.signature && !(payload?.signer?.signature as MediaDto)?.key) {
    //   const file = payload?.signer?.signature as File
    //   payload.signer.signature = await services.media.upload(file) as MediaDto
    // }

    return action
      .Post({
        url: `${path}`,
        body: payload,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public async edit({ idInspection, ...rest }: EditInspectionOutDto) {
    return action
      .Patch({
        url: `${path}/${idInspection}`,
        body: rest.body,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public async getAll({ filters, pagination, sort, group }: GetAllInspectionsOutDto) {
    const filtersJSON = filters && Object.keys(filters).length > 0 ? `&filters=${JSON.stringify(filters)}` : ''

    return action
      .Get({
        url: `${path}/paginated/${paginationString({ pagination, sort, group })}${filtersJSON}`,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public async getOne({ idInspection }: GetOneInspectionOutDto) {
    return action
      .Get({
        url: `${path}/${idInspection}`,
      })
      .then(async (response: InspectionInDto) => {
        const updatedResponse = { ...response };

        // // Handle signer.signature if it exists
        // if (response?.signer?.signature) {
        //   const { key, mimeType } = response?.signer?.signature as MediaDto;
        //   const url = await services.media.download({ key, mimeType });
        //   updatedResponse.signer.signature = { ...response?.signer?.signature, ...url };
        // }

        // // Handle auditor.signature if it exists
        // if (response?.auditor && response?.auditor?.signature) {
        //   const { key, mimeType } = response?.auditor?.signature as MediaDto;
        //   const url = await services.media.download({ key, mimeType });
        //   updatedResponse.auditor.signature = { ...response?.auditor?.signature, ...url };
        // }

        return { response: updatedResponse };
      })
      .catch(error => {
        return { error };
      });
  }

  // public async getOne({ idInspection }: GetOneInspectionOutDto) {
  //   return action
  //     .Get({
  //       url: `${path}/${idInspection}`,
  //     })
  //     .then(async (response: InspectionInDto) => {
  //       if (response.signer.signature) {
  //         const { key, mimeType } = response.signer.signature as MediaDto
  //         const url = await services.media.download({ key, mimeType })
  //         return {
  //           response: {
  //             ...response, signature: {
  //               ...response.signer.signature, ...url
  //             }
  //           }
  //         }
  //       } else {
  //         return { response }
  //       }
  //     })
  //     .catch(error => {
  //       return { error }
  //     })
  // }

  public async deleteOne({ idInspection }: DeleteInspectionOutDto) {
    return action
      .Del({
        url: `${path}/${idInspection}`,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public getMetrics({ filters }: GetInspectionsMetricsOutDto) {
    const filtersJSON = filters ? `?filters=${JSON.stringify(filters)}` : ''

    return action
      .Get({
        url: `${path}/metrics${filtersJSON}`,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public async downloadEmptyInspection({ idCustomer, options }: downloadEmptyInspectionDto) {

    const optionsParam = options?.join(',')
    return action
      .Get({
        url: `${path}/${idCustomer}/download-empty`,
        config: {
          responseType: 'blob',
          params: optionsParam ? { options: optionsParam } : {},
          headers: {
            'Accept': 'application/pdf',
          }
        }
      })

      .then((response) => {

        return { response };
      })
      .catch(error => {
        return { error }
      })
  }

  public async downloadfullinspection({ idInspection }: downloadFullInspectionDto) {
    // Usar axios directamente para tener acceso a los headers
    const BASE_URL = process.env.REACT_APP_API_URL || "/";
    const token = services.auth.getToken() || "";

    return axios
      .get(`${BASE_URL}${path}/${idInspection}/download`, {
        responseType: 'blob',
        headers: {
          'Accept': 'application/pdf',
          ...(token && { authorization: `Bearer ${token}` }),
        },
        withCredentials: true,
      })
      .then((axiosResponse) => {
        // Devolver tanto el blob como los headers
        return { 
          response: axiosResponse.data, 
          headers: axiosResponse.headers 
        };
      })
      .catch(error => {
        return { error }
      })
  }
}

const inspection = new Inspection()
export default inspection
